import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchPreferences } from '../../predict/src/core/api/preferences';
import { queryClient } from '../core/queryClient';

type FetchPreferencesResult = Awaited<ReturnType<typeof fetchPreferences>>;
type PreferencesQueryOptions = Omit<QueryObserverOptions<FetchPreferencesResult>, 'queryKey' | 'queryFn'>;

export const preferencesQueryKey = (organisationId: string, workspaceId: string, userId: string) => [
  'preferences',
  organisationId,
  workspaceId,
  userId
];

export const preferencesQuery = (
  workspaceId: string,
  organisationId: string,
  userId: string,
  options?: PreferencesQueryOptions
): QueryObserver<FetchPreferencesResult> =>
  new QueryObserver<FetchPreferencesResult>(queryClient, {
    queryKey: preferencesQueryKey(organisationId, workspaceId, userId),
    queryFn: () => fetchPreferences(workspaceId, organisationId, userId),
    ...options
  });
